export enum RoleType {
  Chat = 'Chat',
  CustomerPortal = 'CustomerPortal',
}